var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ed-header-sidebar-menu"},[_c('ed-icon',{staticClass:"ed-header-sidebar-menu--icon cursor-pointer",attrs:{"icon":"bars-solid"},nativeOn:{"click":function($event){return _vm.toggleSidebar();}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }